import { useCallback, useLayoutEffect, useRef } from "react";

/**
 * Inserts text at the textarea caret and restores focus after React commits the new value.
 */
export function useInsertAtCursor(markdown, setMarkdown, textareaRef) {
  const pendingCursor = useRef(null);

  useLayoutEffect(() => {
    if (pendingCursor.current == null || !textareaRef.current) return;
    const pos = pendingCursor.current;
    pendingCursor.current = null;
    const el = textareaRef.current;
    el.setSelectionRange(pos, pos);
    el.focus();
  }, [markdown, textareaRef]);

  return useCallback(
    (snippet) => {
      const ta = textareaRef.current;
      if (!ta) {
        setMarkdown((m) => m + snippet);
        return;
      }
      const start = ta.selectionStart;
      const end = ta.selectionEnd;
      pendingCursor.current = start + snippet.length;
      setMarkdown((m) => m.slice(0, start) + snippet + m.slice(end));
    },
    [setMarkdown, textareaRef],
  );
}
